<div *ngIf="arrayPage.length>1" class="align-items-center d-flex flex-column">
    <ul class="flex-wrap justify-content-center pagination">
        <li *ngFor="let e of arrayPage" class="page-item" [ngClass]="{'active':e.active === true}">
            <button class="page-link" (click)="changePage(e.page)" title="{{e.title}}"> <span
                    aria-hidden="true">{{e.label}}</span></button>
        </li>
    </ul>
</div>
 